import { Deserializable } from '../deserializable';
import { LookupCurrencies } from './lookup-currencies';

export class LookupCurrencyExchange implements Deserializable{

    public id: number;
    public name: string;
    public fromCurrency: LookupCurrencies;
    public toCurrency: LookupCurrencies;
    public exchangeRate: number;
    public lastRefreshed: Date;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
